import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { catchError, finalize, takeUntil } from "rxjs/operators";
import { BehaviorSubject, of, Subject } from "rxjs";
import { IComment } from "./comment/comment.component";
import { CommentSendStatus } from "./sender/sender.component";
import { HttpResponse } from "@angular/common/http";
import { CommentsDataSource } from "../../model/comments-data-source.interface";

@Component({
  selector: "ks-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.scss", "./comments.component-modern.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentsComponent implements OnInit {
  @ViewChild("commentsList")
  commentsListWrapperHtmlElement: ElementRef<HTMLDivElement>;

  /**
   * DataSource для работы с комментариями
   */
  @Input()
  commentsDataSource: CommentsDataSource;
  @Output() public longerTask: EventEmitter<IComment> = new EventEmitter();
  @Output() public comparePhoto: EventEmitter<{
    url: string;
    from: "comment" | "task";
  }> = new EventEmitter();
  @Input() user: any;

  /**
   * Статус формы компонента sender
   */
  public sendFormStatus: BehaviorSubject<CommentSendStatus>;

  /**
   * Массив с комментариями
   */
  // public commentsList: IComment[] = null;
  isOpenComparePhoto: boolean = true;
  comparePhotoUrl: string;
  // "https://dl.dropbox.com/scl/fi/2gxb97s4u33wcxyd8hfek/M_241945-_-Marstest_02-_-20240521-_-2-_-14e7d48f-8a87-4fec-97ef-331adfded18e.jpg?rlkey=npj8grt0k8omi2oy8kkce8o2k&dl=0";
  public commentsList: IComment[];
  // [
  //   {
  //     photoCode: "153115",
  //     user: {
  //       id: 37779,
  //       login: "manujlov_ms",
  //       fullName: "Мануйлов Михаил Сергеевич",
  //       photoUrl: "",
  //     },
  //     comment: "1",
  //     commentCreatedDate: "2025-10-17T11:48",
  //     commentCreateTimeStamp: 0,
  //     hasCreateTask: true,
  //     taskId: 1111,
  //   },
  /**
   * Статус загзузки комментариев.
   */
  public isLoading = false;
  /**
   * Observable для отображения ошибки.
   */
  public loadingError$ = new Subject<string>();
  isAllowCreateTask;
  // ];
  /**
   * Subject для отписки.
   */
  private ngUnsubscribe = new Subject();
  private isCommentLoading: boolean = false;

  constructor(private ref: ChangeDetectorRef) {}

  private _id: number;

  get id() {
    return this._id;
  }

  /**
   * Текущий id фотографии
   * @param value
   */
  @Input()
  set id(value) {
    this._id = +value;
    // При смене фото, отменяем предущие запросы и запрашиваем комментарии по id фотографии.
    this.ngUnsubscribe.next();

    if (this.commentsDataSource) {
      this.getComments(this.id);
    }
  }

  ngOnInit() {
    this.getComments(this.id);
  }

  /**
   * Получение списка комментариев по photoId
   * @param photoId
   */
  getComments(photoId: number): void {
    // photoId = 127809780;
    this.isLoading = true;
    this.commentsList = null;

    this.commentsDataSource
      .load(photoId)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.isLoading = false;
        }),
        catchError((error) => {
          console.log(error);
          this.isLoading = false;
          this.loadingError$.next(error);
          return of();
        })
      )
      .subscribe((data) => {
        console.log("coments-subscribe", data);
        this.commentsList = <IComment[]>data.comments;

        this.isAllowCreateTask = data.isAllowCreateTask;
        this.scrollToEnd();
        this.ref.detectChanges();
      });
  }

  /**
   * Отправка сообщения
   * @param message
   */
  sendMessage(message: {
    comment: string;
    photos?: File[];
    isCreateTask: boolean;
  }) {
    // console.log('sendMessage', message)
    if (!message || !message.comment) return;
    if (this.isCommentLoading) return;
    this.isCommentLoading = true;
    this.sendFormStatus.next({ error: "", loading: true });

    this.commentsDataSource
      .insert(this.id, message.comment, message.isCreateTask, message.photos)
      .pipe(
        catchError((error) => {
          this.sendFormStatus.next({ error: error, loading: false });
          this.isCommentLoading = false;
          return of();
        })
      )
      .subscribe((response: HttpResponse<any>) => {
        this.commentsList.push(response.body);

        this.sendFormStatus.next({ error: "", loading: false });
        this.isCommentLoading = false;
        this.scrollToEnd();
        this.ref.detectChanges();
      });
  }

  /**
   * Ускорение перерендеринга.
   * @param index
   * @param item
   */
  trackByFn(index, item) {
    return index;
  }

  scrollToEnd() {
    setTimeout(() => {
      const commentsHtmlElement = this.commentsListWrapperHtmlElement;

      if (commentsHtmlElement) {
        const el = commentsHtmlElement.nativeElement;
        el.scrollTop = el.scrollHeight;
      }
    });
  }

  onComparePhoto(url) {
    console.log("onComparePhoto-comments", url);
    this.comparePhoto.emit(url);
  }
  longTask(comment: IComment) {
    this.longerTask.emit(comment);
  }
}
